import {useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {Dominoes} from 'redux/actions';
import useGroup from 'hooks/useGroup';
import useSetting from 'hooks/useSetting';
import useSession from 'hooks/useSession';

const useDomino = () => {
	const dispatch = useDispatch();
	const {
		dominoes,
		fetching
	} = useSelector((state) => state.dominoes);

	const {
		tools
	} = useSetting();


	const {
		session,
		setup,
		getPixelValue
	} = useSession();

	const {
		group
	} = useGroup();

	let config = {
		DOMINO_WIDTH: getPixelValue(setup.domino.size.thickness),
		DOMINO_HEIGHT: getPixelValue(setup.domino.size.width),
		MARGIN_HEIGHT: getPixelValue(setup.marginHorizontal),
		MARGIN_WIDTH: getPixelValue(setup.marginVertical),
		BG_COLOR: setup.backgroundColor
	};

	if (setup.type === 2) {
		config = {
			DOMINO_WIDTH: getPixelValue(setup.domino.size.width),
			DOMINO_HEIGHT: getPixelValue(setup.domino.size.thickness),
			MARGIN_HEIGHT: getPixelValue(setup.marginHorizontal),
			MARGIN_WIDTH: getPixelValue(setup.marginVertical),
			BG_COLOR: setup.backgroundColor
		};
	}


	if (setup.type === 3) {
		config = {
			DOMINO_WIDTH: getPixelValue(setup.domino.size.width),
			DOMINO_HEIGHT: getPixelValue(setup.domino.size.heightFallWall),
			MARGIN_HEIGHT: 1,
			MARGIN_WIDTH: getPixelValue(setup.marginVertical),
			BG_COLOR: setup.backgroundColor
		};
	}


	const switchColor = (data, callback) => {
		data.session = session;
		data.group = group.id;
		dispatch(Dominoes.switchColor({
			...data
		}, callback));
	};

	const saveSelection = useCallback((data, callback) => {
		data.tools = tools;
		data.session = session;
		dispatch(Dominoes.saveSelection({
			...data
		}, callback));
	}, [tools]);

	const saveMultipleDomino = useCallback((data, callback) => {
		data.tools = tools;
		data.session = session;
		dispatch(Dominoes.saveMultiple({
			...data
		}, callback));
	}, [tools]);

	const setDominoes = (doms) => {
		dispatch(Dominoes.set(doms));
	}

	const parseTo2Decimal = (number) => {
		return Math.round(number * 100) / 100;
	}

	const getLineAndColumn = (clientX, clientY, ignoreMarge = true, currentZoom) => {

		let column = false;
		let line = false;

		for (let i = 0; i < 1000; i++) {
			let dominoWidth = config.DOMINO_WIDTH * currentZoom;
			let margin = config.MARGIN_WIDTH * currentZoom;
			let startXDomino = (dominoWidth + margin);

			if (
				clientX >= i * startXDomino &&
				clientX <= (i * startXDomino) + dominoWidth
			) {
				column = i;
			}
		}

		for (let i = 0; i < 1000; i++) {
			let dominoHeight = config.DOMINO_HEIGHT * currentZoom;
			let margin = config.MARGIN_HEIGHT * currentZoom;
			let startYDomino = dominoHeight + margin;
			if (
				clientY >= i * startYDomino &&
				clientY <= (i * startYDomino) + dominoHeight
			) {
				line = i;
			}
		}

		return {
			line,
			column
		}
	}

	return {
		fetching,
		dominoes,
		setDominoes,
		saveSelection,
		saveMultipleDomino,
		switchColor,
		getLineAndColumn,
		config
	};
};

export default useDomino;
